import React from 'react';

export default function ExploreCard({ icon, title, description, children, selected = false, onClick }) {
  const Tag = onClick ? 'button' : 'div';
  return (
    <Tag type={onClick ? 'button' : undefined} className={`explore-card ${selected ? 'selected' : ''}`} onClick={onClick}>
      {icon && <div className="explore-card-icon">{icon}</div>}
      <div>
        <h3>{title}</h3>
        {description && <p>{description}</p>}
      </div>
      {children}
    </Tag>
  );
}
